import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils';
import specialityService from '@/services/contact/specialityService';

// Contacts store the specialty name itself, so the name is also the value.
const toSpecialityOptions = (rows) =>
  rows.map(speciality => ({
    label: speciality.name,
    value: speciality.name,
  }));

const useSpecialityOptions = ({ defaultPageSize = 20 } = {}) => {
  const loadOptions = useCallback(
    async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
      try {
        const response = await specialityService.getAllSpecialities({
          page,
          pageSize,
          search,
        });

        const status =
          typeof response?.status === 'boolean' ? response.status : true;
        if (!status) return { options: [], hasMore: false };

        const options = toSpecialityOptions(getRows(response));

        const totalRecords = getTotalRecords(response);
        const hasMore =
          typeof totalRecords === 'number'
            ? page * pageSize < totalRecords
            : options.length === pageSize;

        return { options, hasMore };
      } catch (error) {
        console.error('Error', error);
        toast.error('Failed to fetch Specialties.', {
          description: 'Please try again.',
        });
        return { options: [], hasMore: false };
      }
    },
    [defaultPageSize]
  );

  return loadOptions;
};

export { useSpecialityOptions };
